<mat-form-field appearance="outline" class="w-100">
<mat-label>{{ translateFieldName(fieldObject) }}</mat-label>
<input type="text" placeholder="{{ translateFieldName(fieldObject) }}"
       [attr.disabled]="(productType === 6 && formControlRef.value && isUpdate ) ? true:null"
       [formControl]="formControlRef" class="form-control" matInput />
<mat-error class="text-danger" *ngIf="fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName]">
  {{ fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName] }}
</mat-error>
</mat-form-field>
